import React from 'react';

class Text extends React.Component {
    render() {
            return (
                <h3> 
                     Nuestra Ubicacion <br></br>
                        <br></br>
                        Calle 23#55-94 <br></br>
                        Bello Cabañitas <br></br>
                        Horario de atención: <br></br>
                        Lunes a Viernes desde <br></br>
                        16:00 hasta las 21:00 <br></br>
                        Sabados, Domingos y Festivos <br></br>
                        Desde 14:00 hasta las 20:00 
                </h3>
            );
    }
}

export default Text;

